import React from 'react';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import * as MdIcons from 'react-icons/md';
import { Link } from 'react-router-dom'

const StyledButton = styled.div`
  color: white;
  align-text: center;
  z-index: 2;
  &:hover{
    cursor: pointer;
  }
`;
const linkStyle = {
  margin: "1rem",
  textDecoration: "none",
  color: 'white'
};

const SearchButton = () => {
  return (
    <Tooltip title="Sök">
      <StyledButton> <Link to="/search" style={linkStyle} > <MdIcons.MdSearch size={40} /> </Link></StyledButton>
    </Tooltip>
  )
}

export default SearchButton
